/**
 * Beacons de telemetría UDV → ingest (Fase 4).
 * Sin StudyUID en payload (solo agregados Prometheus en ingest).
 *
 * Tenant y URL: sesión ticket/plataforma → env build-time (ver udvTelemetryContext.js).
 */

import { resolveUdvTelemetryTarget } from './udvTelemetryContext'

/**
 * @returns {boolean}
 */
export function isUdvTelemetryEnabled() {
  return resolveUdvTelemetryTarget().enabled
}

/**
 * @param {'first_preview_paint'|'manifest_upgrade'|'diag_available'} event
 * @param {{ durationMs?: number, modality?: string|null, tenant?: string, telemetryBaseUrl?: string, telemetryToken?: string }} [opts]
 */
export function sendUdvTelemetryBeacon(event, opts) {
  const target = resolveUdvTelemetryTarget(opts)
  if (!target.enabled) return

  const durationMs = opts && Number.isFinite(opts.durationMs) ? Math.round(opts.durationMs) : 0
  if (durationMs < 0) return

  const url = `${target.baseUrl}/v1/telemetry/beacon?tenant_id=${encodeURIComponent(target.tenant)}`
  const body = JSON.stringify({
    event,
    duration_ms: durationMs,
    modality: opts && opts.modality ? String(opts.modality).slice(0, 16) : null,
  })

  const headers = { 'Content-Type': 'application/json' }
  if (target.token) headers.Authorization = `Bearer ${target.token}`

  // sendBeacon no permite Authorization; con token usamos fetch keepalive.
  if (!target.token) {
    try {
      if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
        const blob = new Blob([body], { type: 'application/json' })
        const ok = navigator.sendBeacon(url, blob)
        if (ok) return
      }
    } catch (_) {
      /* fall through */
    }
  }

  try {
    void fetch(url, {
      method: 'POST',
      headers,
      body,
      keepalive: true,
      mode: 'cors',
      credentials: 'omit',
    }).catch(() => {
      /* silencioso — no afecta visor (CORS/401) */
    })
  } catch (_) {
    /* ignore */
  }
}
